import React from 'react'
import { createMultipleSelectOptions } from '../../util'
import { FormFieldsCollectionSelect } from '.'

const FormFieldsSidebarProjects = props => {
  return (
    <FormFieldsCollectionSelect
      collection="projects"
      options={createMultipleSelectOptions(props, 'projects')}
      item={props.item}
      type={props.type}
      projects={props.projects}
      schema={props.schema}
      classes={props.classes}
      createInputData={props.createInputData}
      processing={props.processing}
      handleChange={props.handleChange}
    />
  )
}

export default FormFieldsSidebarProjects
